'use client';

import { FC, ReactNode } from 'react';
import {
  isRtlLanguageFromLocale,
  useClientLocale,
} from '@bts-web/utils-lokalise';
import { submitButtonWrapper } from '../../utils/styles';

interface SubmitButtonWrapperProps {
  children: ReactNode;
}

export const SubmitButtonWrapper: FC<SubmitButtonWrapperProps> = ({
  children,
}) => {
  const currentLocale = useClientLocale();

  const isRTL = isRtlLanguageFromLocale(currentLocale);

  return (
    <div dir={isRTL ? 'rtl' : 'ltr'} className={submitButtonWrapper}>
      {children}
    </div>
  );
};
